// Fixed emoji per canonical language (BOOK_LANGUAGES in mockData.js) — a
// presentation-only mapping for a closed, known set, not a business rule.
// Shared by BookDetailPage and the Reading Page's TranslateMenu so both
// surfaces show the same flag for the same language (Modular Architecture).
export const LANGUAGE_FLAG = {
  English: '🇬🇧', Swahili: '🇰🇪', Yoruba: '🇳🇬', Zulu: '🇿🇦', French: '🇫🇷',
  Hausa: '🇳🇬', Igbo: '🇳🇬', Pidgin: '🇳🇬', Kanuri: '🇳🇬', Tiv: '🇳🇬', Efik: '🇳🇬',
};
